export async function getImageFileFromURL(imageURL: string, title: string) {
  const response = await fetch(imageURL);
  const blob = await response.blob();

  return new File([blob], title, { type: blob.type });
}
